module.exports = __webpack_public_path__ + "assets/images/amira_view_report_alert_modal_open.88eae6c47872bf75641c68aea62614f4.svg";